// api/queryFileExtensions.ts
import { baseqlMetaData } from "@adornis/baseql/metadata/metaDataStore.js";
import { registerQuery } from "@adornis/baseql/metadata/register.js";
import { getRawCollection } from "@adornis/baseql/server/collections.js";
import "@adornis/file-utils/db/files.js";
var queryFileExtensionsResolver = (fileClassNames) => {
  return async () => {
    const resolvedFileClasses = fileClassNames.map((fileClassName) => {
      return baseqlMetaData.entities.resolveNode(fileClassName).type();
    });
    if (!resolvedFileClasses[0])
      return [];
    const rawCollection = await getRawCollection(resolvedFileClasses[0]._collectionName);
    resolvedFileClasses.splice(0, 1);
    const result = await rawCollection.aggregate([
      // * publishfilter hier noch einbauen
      ...resolvedFileClasses.map((fileClass) => {
        return {
          $unionWith: {
            coll: fileClass._collectionName
          }
        };
      }),
      {
        $project: {
          meta: {
            extension: 1
          }
        }
      },
      {
        $match: {
          "meta.extension": { $exists: true, $ne: null }
        }
      },
      {
        $group: {
          _id: { $toLower: "$meta.extension" },
          // Gruppiere nach `meta.extension`
          count: { $sum: 1 }
          // Zähle die Anzahl der Vorkommen
        }
      },
      {
        $project: {
          _id: 0,
          extension: "$_id",
          // Benenne `_id` in `extension` um
          count: 1
          // Behalte `count` im Ergebnis
        }
      },
      // 3. Optional: Nach Anzahl sortieren (absteigend)
      {
        $sort: { count: -1 }
      }
    ]).toArray();
    return result.map((res) => res.extension);
  };
};
var queryFileExtensions = registerQuery({
  type: () => [String],
  operationName: "queryFileExtensions",
  resolve: queryFileExtensionsResolver,
  params: [{ type: () => [String], name: "fileClassNames" }]
});
export {
  queryFileExtensions
};
